var _path, _rect, _path2, _rect2, _path3, _path4, _rect3, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Connected energy, retail and telecom services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h70M40 48l36 48m44-48-36 48",
    stroke: "#B69782",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 49,
    height: 49,
    rx: 8,
    fill: "#45556D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42 26-14 20h11l-3 14 16-23H41Z",
    fill: "#E8EDF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 18,
    width: 45,
    height: 54,
    rx: 7,
    fill: "#D7E0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 37v-4a10 10 0 0 1 20 0v4",
    stroke: "#596475",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47h23M110 57h16",
    stroke: "#A6B2C2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 77,
    width: 42,
    height: 42,
    rx: 8,
    fill: "#D7E0EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 107V97m-9 0a13 13 0 0 1 18 0m-24-7a22 22 0 0 1 30 0",
    stroke: "#596475",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 109,
    r: 3,
    fill: "#357653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureEnterprise);
export default __webpack_public_path__ + "static/media/feature-enterprise.a5622a29cd4461d8dbe99f2fef897154.svg";
export { ForwardRef as ReactComponent };